import { useMutation } from '@tanstack/react-query';

import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';

import { activityLogsKeys } from './getActivityLogs';
import { fileDetailsKeys } from './getFileDetails';

import { isResponseError } from '../../../../api/config';
import { updateWebAppFileStatus } from '../../../../api/updateWebAppFileStatus';

type UpdateFileStatusOptions = {
  fileId: number;
  projectId: string;
  config?: MutationConfig<typeof updateWebAppFileStatus>;
};

export const useUpdateFileStatus = ({ fileId, projectId, config }: UpdateFileStatusOptions) => {
  return useMutation({
    onSuccess: (data) => {
      if (isResponseError(data)) {
        return;
      }

      queryClient.setQueryData([...fileDetailsKeys.detail({ fileId })], (prev: any) => {
        return {
          ...prev,
          data: data.data['inbox-document'],
        };
      });

      queryClient.invalidateQueries([...activityLogsKeys.list(fileId)]);
      // queryClient.invalidateQueries([...inboxEntriesKeys.lists({ projectId })]);

      // Use this if we want to retain the sidebar entry even if its status changed
      // queryClient.setQueriesData([...inboxEntriesKeys.lists({ projectId })], (prev: any) => {
      //   return {
      //     ...prev,
      //     pages: prev.pages.map((page) => {
      //       return {
      //         ...page,
      //         data: page.data.map((inboxEntry) => {
      //           if (inboxEntry.document?.id === fileId) {
      //             return {
      //               ...inboxEntry,
      //               status: data.data.status,
      //             };
      //           }

      //           return inboxEntry;
      //         }),
      //       };
      //     }),
      //   };
      // });
      // updateFilterStatusCounters({ projectId, newStatus: data.data['inbox-entry'].status });
    },
    ...config,
    mutationFn: ({ status }) => updateWebAppFileStatus({ fileId, status }),
  });
};
